// extracted by mini-css-extract-plugin
module.exports = {"UppyDashboardContainer":"PostFormUppy_UppyDashboardContainer__3bEvU","InitialScreen":"PostFormUppy_InitialScreen__ACZFz"};